document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('videoForm');
    if (!form) {
    console.warn('no exist videoForm');
    return; // 以降の処理を止める（なければ処理不要なので）
  }

  const submitBtn = document.getElementById('submitBtn');
  const uploadForm = document.querySelector('upload-form');
  const isEdit = form.dataset.edit === 'true';

  // グローバル変数でアップロード状態を保持
  window.__uploadStatus__ = {
    isUploading: false,
    isUploaded: false,
    filename: ''
  };

  // Vue側からのイベントを受け取る
  if (uploadForm) {
    uploadForm.addEventListener('uploading', function(e) {
      const status = window.__uploadStatus__;
      status.isUploading = e.detail;
      if (!status.isUploading) {
        status.isUploaded = true;
      }
      console.log('uploading event: ', e.detail);
    });
  } else {
    console.warn('no exist upload-form');
  }

  // submitボタンのクリックイベント
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();

      const status = window.__uploadStatus__;
      console.log('isUploading:', status.isUploading, 'isUploaded:', status.isUploaded);

    if (!isEdit) {
      if (status.isUploading) {
        alert('アップロード中です。完了するまでお待ちください。');
        return;
      }

      if (!status.isUploaded) {
        alert('ファイルがアップロードされていません。');
        return;
      }
    }
      form.submit();
    });
  }
});
